<script>
    import Modal from '../../Modal.svelte';
	import { modal } from '../../stores.js';
    import PopupEditSource from './popup.svelte';
    export let feedSource;
    export let tagOptions;
</script>

<Modal show={$modal}>
    <PopupEditSource feedSource={feedSource} tagOptions={tagOptions} />
</Modal>